import { useCallback } from 'react';
import { toast } from 'react-toastify';

import { dashboardApi } from '@services/api/dashboard';
import { getToken } from '@utils/auth';
import { getExportErrorMessage } from '@utils/downloadCsv';

const getAuthToken = () => getToken({ type: 'client' });

const handleExportError = async (error) => {
  const message = await getExportErrorMessage(error);
  toast.error(message);
};

export function useDashboardExport() {
  const exportWidgets = useCallback(async () => {
    try {
      await dashboardApi.exportWidgets({ token: getAuthToken() });
    } catch (error) {
      await handleExportError(error);
    }
  }, []);

  const exportRanking = useCallback(async (params = {}) => {
    try {
      await dashboardApi.exportRanking({ token: getAuthToken(), params });
    } catch (error) {
      await handleExportError(error);
    }
  }, []);

  const exportSessions = useCallback(async (params = {}) => {
    try {
      await dashboardApi.exportSessions({ token: getAuthToken(), params });
    } catch (error) {
      await handleExportError(error);
    }
  }, []);

  const exportMostAccessedContent = useCallback(async (params = {}) => {
    try {
      await dashboardApi.exportMostAccessedContent({
        token: getAuthToken(),
        params,
      });
    } catch (error) {
      await handleExportError(error);
    }
  }, []);

  const exportChartSteps = useCallback(async (params = {}) => {
    try {
      await dashboardApi.exportChartSteps({ token: getAuthToken(), params });
    } catch (error) {
      await handleExportError(error);
    }
  }, []);

  const exportChartAccesses = useCallback(async (params = {}) => {
    try {
      await dashboardApi.exportChartAccesses({ token: getAuthToken(), params });
    } catch (error) {
      await handleExportError(error);
    }
  }, []);

  const exportChartSessions = useCallback(async (params = {}) => {
    try {
      await dashboardApi.exportChartSessions({ token: getAuthToken(), params });
    } catch (error) {
      await handleExportError(error);
    }
  }, []);

  const exportAll = useCallback(async (params = {}) => {
    try {
      await dashboardApi.exportAll({ token: getAuthToken(), params });
    } catch (error) {
      await handleExportError(error);
    }
  }, []);

  const exportConsolidated = useCallback(async (params = {}) => {
    try {
      await dashboardApi.exportConsolidated({ token: getAuthToken(), params });
    } catch (error) {
      await handleExportError(error);
    }
  }, []);

  return {
    exportWidgets,
    exportRanking,
    exportSessions,
    exportMostAccessedContent,
    exportChartSteps,
    exportChartAccesses,
    exportChartSessions,
    exportAll,
    exportConsolidated,
  };
}

export default useDashboardExport;
